import { render, staticRenderFns } from "./DeviceDetailsG2Link.vue?vue&type=template&id=25e16880&"
import script from "./DeviceDetailsG2Link.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailsG2Link.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetailsG2Link.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports